import React from 'react'
import { Link } from "gatsby"
import { FormattedMessage } from 'react-intl'

export default ({ homeLink, sitemapComponent, lang }) => (
  <footer>
    <div className="bg-yellow-500 pt-8 pb-4">
      <div className="container">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8">
          <Link to={homeLink} className="w-2/3 md:w-auto md:h-18 md:mr-4 mb-8 md:mb-0">
            <img className="w-full" src="/AnnualReport2017-2018/images/ift-logo-light.svg" alt="ift-logo-light" />
          </Link>

          <a href={`/AnnualReport2017-2018/annual-report-201718-${lang}.pdf`} download className="w-2/3 md:w-1/2 lg:w-1/3 text-yellow-500 px-6 py-4 bg-white hover:bg-yellow-100 text-lg md:text-xl uppercase text-center shadow-md">
            <FormattedMessage id="Download Year Report" />
          </a>
        </div>
      </div>
      <div className="mx-4 lg:mx-8">
        { sitemapComponent() }
      </div>
    </div>

    <div className="font-normal bg-black py-2 md:py-0">
      <div className="container py-2 text-white text-sm flex flex-col md:flex-row justify-between items-center">
        <ul className="flex flex-row flex-wrap items-center justify-center mb-4 md:mb-0">
          <li><FormattedMessage id="Address" />: <FormattedMessage id="IFT address" /></li>
          <li className="h-4 border-r border-white mx-2"></li>
          <li><FormattedMessage id="E-mail" />: <a href="mailto:iftpr@ift.edu.mo">iftpr@ift.edu.mo</a></li>
          <li className="hidden md:block h-4 border-r border-white mx-2"></li>
          <li className="w-full my-px md:hidden"></li>
          <li><FormattedMessage id="Phone" />: <a href="tel:853-2856-1252">(853) 28561252</a></li>
          <li className="h-4 border-r border-white mx-2"></li>
          <li><FormattedMessage id="Fax" />: (853) 2851 9058</li>
        </ul>

        <div>
          &copy; <FormattedMessage id="Footer copyright text" />
        </div>
      </div>
    </div>
  </footer>
)
